async function getSidebarMarkup( {name = ''} = {} ){

    if( name ){

        const url = `${adw.siteurl}/wp-json/wp/v2/widgets/?sidebar=${name}`;
        const widgets = await fetch(url).then( res => res?.json?.() );

        const markup = widgets?.map( widget => widget.rendered ).reduce( (prev, curr) => prev + curr, '' );

        return markup;
      
    }

}

function getDeferredSidebarsFromMarkup(){

    const sidebarEls = document.querySelectorAll( '[data-deferred-sidebar]' );
    const sidebars = [...sidebarEls]?.map?.( sidebarEl => sidebarEl.dataset.deferredSidebar );
    return {sidebars, sidebarEls};

}

function loadDeferredSidebarContents(){

    const {sidebars, sidebarEls} = getDeferredSidebarsFromMarkup();
    sidebars.forEach( async (sidebarName, i) => {

        const sidebarEl = sidebarEls[i];

        const handleIntersect = (entries, observer) => {

            entries.forEach((entry) => {
                if (entry.isIntersecting) {

                    const loadContent = async () => {

                        if( sidebarEl?.dataset?.loaded !== 'true' ){
        
                            sidebarEl.dataset.loaded = 'true';
                            
                            // Load sidebar content when scrolled into view
                            const markup = await getSidebarMarkup( {name: sidebarName} );

                            sidebarEl.innerHTML = markup;

                            const eventSidebarLoaded = new CustomEvent( `sidebarLoaded`, {
                                detail: {
                                    sidebarName
                                }
                            } );

                            window.dispatchEvent( eventSidebarLoaded );

                        }

                    }

                    loadContent();
        
                }
            });
        }
    
        let observer;
    
        let options = {
            root: null,
            rootMargin: "300px",
            threshold: [0]
        };
    
        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe( sidebarEl );
        
    });


}

loadDeferredSidebarContents();